import { getBadgeTier } from '@/lib/reviewBadge';

// A small moka pot (stovetop espresso maker) SVG badge, colored by tier.
export default function MokaPotBadge({ reviewCount = 0, size = 16 }) {
  const tier = getBadgeTier(reviewCount);
  if (!tier) return null;

  return (
    <span title={`${tier.label} · ${reviewCount} reviews`} className="inline-flex items-center shrink-0">
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label={tier.label}
      >
        {/* Top chamber (trapezoid) */}
        <path d="M7 3 L17 3 L15.5 9 L8.5 9 Z" fill={tier.color} fillOpacity="0.85" />
        {/* Lid knob */}
        <rect x="11" y="1" width="2" height="2.2" rx="1" fill={tier.color} />
        {/* Handle */}
        <path d="M16 11 q4 0.5 3.5 5" stroke={tier.color} strokeWidth="1.6" fill="none" strokeLinecap="round" />
        {/* Bottom chamber (tapered) */}
        <path d="M8.5 10 L15.5 10 L14 20 L10 20 Z" fill={tier.color} />
        {/* Spout */}
        <path d="M8.5 10 L6 11.5 L7.2 12.5 L9 11.2 Z" fill={tier.color} fillOpacity="0.9" />
      </svg>
    </span>
  );
}